import {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {useTranslation} from "react-i18next";
import {questionnaireActions} from "_actions";
import * as _ from 'lodash';
import {history} from '_helpers/history'
import {Checkbox, Button, notification, Modal} from 'antd';
import "./startCeiba.scss";
import Headerbutton from "../component/headerButton";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {ArrowRightOutlined, QuestionCircleOutlined, EditOutlined, ReloadOutlined} from "@ant-design/icons";
import have from "../../../assets/img/have.png";
import like from "../../../assets/img/like.png";
import then from "../../../assets/img/then.png";
import study from "../../../assets/img/study.png";
import work from "../../../assets/img/work.png";
import SliderV from "../../../components/Slider/SliderV";

function EndCeibaPage(props) {

    const dispatch = useDispatch();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t, i18n} = useTranslation();
    const [area, setArea] = useState(null);
    const [answer, setAnswer] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [checkeds, setCheckeds] = useState([]);
    const [points, setPoints] = useState(0)

    const [itemAjar, setItem] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalSelection, setShowModalSelection] = useState(true);

    var answersData = useSelector((state) => state.questionnaireReducer.answersData);
    var answersDataError = useSelector((state) => state.questionnaireReducer.answersDataError);

    var saveAnswer = useSelector((state) => state.questionnaireReducer.saveAnswer);



    const [unsureValue, setUnsureValue] = useState(false);
    useEffect(() => {
        if (saveAnswer){
            setShowModal(false)
            setArea(null)
            setPoints(0);
            dispatch(questionnaireActions.getAssessmentsCode("CEIBA"))
            dispatch(questionnaireActions.getAnswers("CEIBA"))
        }
    },[saveAnswer])
    useEffect(() => {
        let mData = localStorage.getItem(variables.AREASSEL);
        if (mData && JSON.parse(mData)) {
            setCheckeds(JSON.parse(mData));
        }
    }, [])

    useEffect(() => {
        if (answersData) {
            setAnswers(answersData);
        }
    }, [answersData, answersDataError])

    useEffect(() => {
        dispatch(questionnaireActions.getAssessmentsCode("CEIBA"))
        dispatch(questionnaireActions.getAnswers("CEIBA"))
    }, []);


    const onChange = (e) => {

        if (e.target.checked) {
            if (checkeds.length === 4) {
                e.target.checked = false;
                notification["warning"]({
                    message: t("warning"),
                    description:
                        t("ceiba.nomas4"),
                });
            } else {
                setCheckeds(checkeds => [...checkeds, e.target.value]);
            }
        } else {

            setCheckeds(checkeds => checkeds.filter(el => el.id !== e.target.value.id));
        }
    };
    const startGame = () => {


        localStorage.setItem(variables.AREASSEL, JSON.stringify(checkeds));
        history.push("/admin/ceiba-game");

    }

    const Continue = () => {
        setShowModal(false)
        setArea(null)
        dispatch(questionnaireActions.getAssessmentsCode("CEIBA"))
        dispatch(questionnaireActions.getAnswers("CEIBA"))
    }

    const saveAndContinue = () => {
        localStorage.removeItem(variables.LASTXCELENCE);
        localStorage.removeItem(variables.LASTCEIBA);
        history.push("/admin/assessment")
    }

    const openModal = (item, showSelection=true) => {

        setShowModalSelection(showSelection);
        let mAnswer = answers.filter(it => it.assessment_id === item.id);
        if (mAnswer && mAnswer[0]) {
            setUnsureValue(false);
            setAnswer(mAnswer[0]);
            setPoints(mAnswer[0].points ? mAnswer[0].points === 99 ? 0 :  mAnswer[0].points : 0);
            setShowModal(true)
            setArea(item)
            if(mAnswer[0].points===99 || mAnswer[0].points===999) setUnsureValue(true);

        }

    }

    function onChangeValue(value) {
        setPoints(value)
    }

    const saveResponse = () => {
        let mPoints = points;
        if (unsureValue){
            mPoints = 999;
        }
        dispatch(questionnaireActions.saveAnswer({
            points: mPoints,
            assessment_id: area.id
        }))
    }
    return (
        <div className={"backGroundCeiba"}>

            {showModal &&
                <Modal className={"modalName modal-question"} title={t("ceiba.modificar")}
                       centered
                       visible={showModal} onOk={Continue}
                       onCancel={Continue}>
                    <div className={"container-question"}>
                        <div className={"container-question__auto-margin"}>
                            <div className={"question__header"}>
                                <img className={"question__header-icon"} src={`/assets/img/${area.area.image}`}/>
                                <span className={"title"}>&nbsp;&nbsp;{area.area.name}</span>
                            </div>
                            <div className={"question__content"}>
                                <div className={"question__content-mid"}>
                                    {area.area.has &&
                                      <div className={"container-line"}>
                                          <img className={"container-line__icon"} src={have}/>
                                          <p className={"container-line__text"}>
                                              <strong>{t("ceiba.have")}</strong>&nbsp;
                                              {area.area.has}
                                          </p>
                                      </div>
                                    }
                                    {area.area.like &&
                                      <div className={"container-line"}>
                                          <img className={"container-line__icon"} src={like}/>
                                          <p className={"container-line__text"}>
                                              <strong>{t("ceiba.like")}</strong>&nbsp;
                                              {area.area.like}
                                          </p>
                                      </div>
                                    }
                                    {area.area.then &&
                                      <div className={"container-line"}>
                                          <img className={"container-line__icon"} src={then}/>
                                          <p className={"container-line__text"}>
                                              <strong>{t("ceiba.then")}</strong>&nbsp;
                                              {area.area.then}
                                          </p>
                                      </div>
                                    }
                                    {area.area.study &&
                                      <div className={"container-line"}>
                                          <img className={"container-line__icon"} src={study}/>
                                          <p className={"container-line__text"}>
                                              <strong>{t("ceiba.make")}</strong>&nbsp;
                                              {area.area.study}
                                          </p>
                                      </div>
                                    }
                                    {area.area.work &&
                                      <div className={"container-line"}>
                                          <img className={"container-line__icon"} src={work}/>
                                          <p className={"container-line__text"}>
                                              <strong>{t("ceiba.work")}</strong>&nbsp;
                                              {area.area.work}
                                          </p>
                                      </div>
                                    }
                                    {showModalSelection && <div className={"question__content-mid__question"}>
                                        <p><strong>{t("ceiba.interesante")}</strong></p>
                                        <div className={"text-check"}>
                                            <p>{area.question}</p>
                                        </div>
                                        <>
                                            <Checkbox style={{color: "white", fontWeight: 500}}
                                                      onChange={(val)=>setUnsureValue(val.target.checked)}
                                                      checked={unsureValue}>
                                                <strong>{t("indeciso")}</strong>
                                            </Checkbox>

                                            <>
                                                <SliderV
                                                  dots={true}
                                                  style={{marginTop: 20}}
                                                  step={1}
                                                  value={points}
                                                  onChange={onChangeValue}
                                                  disabled={unsureValue}
                                                  min={1}
                                                  max={10}
                                                />
                                            </>
                                        </>
                                    </div>}
                                </div>
                                <div className={"question__content-bottom"}>
                                    <Button onClick={() => saveResponse()}

                                            type={"primary"}
                                            className="primaryButton buttonSizeO"
                                    >
                                        {showModalSelection?t("saveclose"):t("close")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            }
            <div className={"wrapper-question boxed"}>
                <div className={"insideCeiba boxed"}>
                    <Headerbutton saveAndContinue={saveAndContinue}  noSave={true} title={t("ceiba.title")}/>
                </div>
                <div className={"container-question container-question__end"}>
                    <div className={"container-question__auto-margin"}>
                        <div className={"question__header"}>
                            <img className={"question__header-icon"} src={`/assets/img/report.png`}/>
                            <h2>{t("ceiba.resumen")}</h2>
                        </div>
                        <div className={"question__subheader"} dangerouslySetInnerHTML={{__html: t('ceiba.resumendesc')}}/>
                        <div className={"question__content"}>
                            <div className={"question__content-list"}>
                                {answers.map (item => (
                                    <div className={"list-item"}>
                                            <div className={"list-item-l"}>
                                                <Checkbox
                                                    disabled={item.points < 5 || item.points === 999}
                                                    checked={checkeds.filter(el => el.id === item.assessment.area.id).length > 0}
                                                    value={item.assessment.area} onChange={onChange}>

                                                    <div style={{display: "flex", alignItems:"center"}}>
                                                        <img className={"list-item__icon"} src={`/assets/img/${item.assessment.area.image}`}/>
                                                        <div
                                                            className={`list-item__text ${checkeds.filter(el => el.id === item.assessment.area.id).length > 0 ? 'checkedt' : 'uncheckedt'}`}>
                                                            <div style={{display: "flex", lineHeight: "17px"}}>{item.assessment.area.name} <div style={{display: "flex", alignItems:"center", marginLeft: "4px", cursor: "pointer"}} onClick={() => openModal(item.assessment,false)}><QuestionCircleOutlined /></div></div>
                                                        </div>
                                                    </div>
                                                </Checkbox>
                                                 <>
                                                    {item.points !== 999 ?
                                                      <div className={"content-bar"}>
                                                        <div style={{
                                                            borderRadius: 18,
                                                            width: `${(10 * item.points)}%`
                                                            }}
                                                             className={`list-item__points ${item.points > 0 && item.points < 5 ? "list-item__points--red" :
                                                                 item.points >= 5 && item.points < 8 ? "list-item__points--yellow" : item.points===999?"":"list-item__points--green"
                                                             }`}>
                                                            {item.points!==999?item.points:t('indeciso')} <span>{item.points!==999&&t("ceiba.puntos")}</span>
                                                        </div>
                                                      </div>
                                                      :
                                                        <p className={"list-item__points list-item__points--idk"} style={{color: "#8C8C8C"}}>{t("indeciso")}</p>
                                                    }
                                                </>
                                            </div>
                                            <div
                                                 className={"modifica"} onClick={() => openModal(item.assessment)}>
                                                {t("ceiba.modificar")}&nbsp;<EditOutlined/>
                                            </div>
                                        </div>
                                ))}
                            </div>
                            <div className={"question__content-bottom"}>
                                <div className="left">
                                    <Button
                                        disabled={false}
                                        icon={<ReloadOutlined />}
                                        onClick={() => history.push('/admin/ceiba-instructions?restart=true')}
                                        type={"secondary"}
                                        className="primaryButton"
                                    >
                                        {t("reset")}
                                    </Button>
                                </div>
                                <div className="right">
                                    <Button
                                      disabled={checkeds.length !== 4}
                                      icon={<ArrowRightOutlined/>}
                                      onClick={() => startGame()}
                                      type={"primary"}
                                      className="primaryButton"
                                    >
                                        {t("next")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {itemAjar &&
                <Modal className={"modalName"}
                       bodyStyle={{height: 500}}
                       title={itemAjar.assessment.area.name} width={750} visible={showModal}
                       onOk={Continue} onCancel={Continue}>

                    <div className={"modalInfoArea"}>
                        {itemAjar.assessment.area.has &&
                            <div className={"container-line"}>
                                <div>
                                    <img className={"container-line__icon"} src={have}/>
                                    <span className={"titleItem"}>{t("ceiba.have")}</span>&nbsp;
                                    <span className={"subTitleItem"}>{itemAjar.assessment.area.has}</span>
                                </div>
                            </div>
                        }
                        {itemAjar.assessment.area.like &&
                            <div className={"container-line"}>
                                <div>
                                    <img className={"container-line__icon"} src={like}/>
                                    <span className={"titleItem"}>{t("ceiba.like")}</span>&nbsp;
                                    <span className={"subTitleItem"}>{itemAjar.assessment.area.like}</span>
                                </div>
                            </div>
                        }
                        {itemAjar.assessment.area.the &&
                            <div className={"container-line"}>
                                <div>
                                    <img className={"container-line__icon"} src={then}/>
                                    <span className={"titleItem"}>{t("ceiba.then")}</span>&nbsp;
                                    <span className={"subTitleItem"}>{itemAjar.assessment.area.then}</span>
                                </div>
                            </div>
                        }
                        {itemAjar.assessment.area.study &&
                            <div className={"container-line"}>
                                <div>
                                    <img className={"container-line__icon"} src={study}/>
                                    <span className={"titleItem"}>{t("ceiba.make")}</span>&nbsp;
                                    <span className={"subTitleItem"}>{itemAjar.assessment.area.study}</span>
                                </div>
                            </div>
                        }
                        {itemAjar.assessment.area.work &&
                            <div className={"container-line"}>
                                <div>
                                    <img className={"container-line__icon"} src={work}/>
                                    <span className={"titleItem"}>{t("ceiba.work")}</span>&nbsp;
                                    <span className={"subTitleItem"}>{itemAjar.assessment.area.work}</span>
                                </div>
                            </div>
                        }

                    </div>
                </Modal>
            }
        </div>
    )
}

export default withTranslation()(EndCeibaPage);
